module.exports = __webpack_public_path__ + "img/icon1.d9f96ccf.png";